import {LABELS} from './constants/labels'
import {IssueFieldTextEditor, type IssueFieldTextEditorProps} from './IssueFieldTextEditor'

type IssueFieldNumberEditorProps = IssueFieldTextEditorProps

// Regex to validate number format
const NUMBER_PATTERN = /^-?\d+(\.\d+)?$/
const MAX_INTEGER_VALUE = 2147483647
const MIN_INTEGER_VALUE = -2147483648

export const numberValidation = (value: string): string | null => {
  // we allow for the field to be cleared, so that it would be removed on refresh
  if (value === '') {
    return null
  }
  if (!NUMBER_PATTERN.test(value)) {
    return LABELS.numberValidation.errorMessage
  }

  // Check 32-bit signed integer limits (matching backend)
  const parsed = parseFloat(value)

  if (parsed > MAX_INTEGER_VALUE) {
    return LABELS.numberValidation.max(MAX_INTEGER_VALUE)
  }

  if (parsed < MIN_INTEGER_VALUE) {
    return LABELS.numberValidation.min(MIN_INTEGER_VALUE)
  }

  return null
}

export const IssueFieldNumberEditor = (props: IssueFieldNumberEditorProps) => {
  return (
    <IssueFieldTextEditor
      {...props}
      inputProps={{
        placeholder: LABELS.numberEditorPlaceholder,
        inputMode: 'numeric',
      }}
      validate={numberValidation}
      isNumber
      className={props.className}
    />
  )
}

try{ NUMBER_PATTERN.displayName ||= 'NUMBER_PATTERN' } catch {}
try{ IssueFieldNumberEditor.displayName ||= 'IssueFieldNumberEditor' } catch {}